// extracted by mini-css-extract-plugin
export var iconsContainer = "styles-module--iconsContainer--eb08b";
export var social = "styles-module--social--60dd1";
export var socialLinks = "styles-module--socialLinks--a0292";
export var title = "styles-module--title--0bacd";